export default __webpack_public_path__ + "static/media/ogunlana.9951c0c8.png";